module.exports = __webpack_public_path__ + "img/pic-right.8fda8c4b.svg";